/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputField/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaInputAddressPicker from 'DesignSystem/TysiaInput/TysiaInputAddressPicker/index'
import TysiaInputDatePicker from 'DesignSystem/TysiaInput/TysiaInputDatePicker/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputField({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputField",
  autoFocus,
  autoCapitalize,
  textContentType,
  type = "text",
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onKeyUp,
  value,
  disabled,
  min,
  max,
  step,
  lang,
  size,
  shouldRenderDatePicker,
  containerRef,
  disableFuture,
  dateFuture,
  disablePast,
  datePast,
  yearPicker,
  shouldRenderAddressPicker,
  onChooseAddress
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="TysiaInputField.Capture"
  data-view-path={viewPath}
 autoFocus={autoFocus}
 placeholder={type == "date" ? "MM/dd/yyyy" : placeholder}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={value}
 disabled={disabled}
 min={min}
 max={max}
 step={step}
 lang={lang}
 style={{'--c-1-Z1jPIPE': dtColorsNeutral900,'--fs-2-Z1jPIPE': size == "small" ? "12px" : "13px",'--lh-3-Z1jPIPE': size == "small" ? "16px" : "20px"}}
 className={`views-capture ${styles.Capture}`}
/>
<fromFlow.When is={shouldRenderDatePicker}>
<TysiaInputDatePicker
  viewPath={`${viewPath}/TysiaInputDatePicker`}
 innerRef={containerRef}
 onChange={onChange}
 value={value}
 disableFuture={disableFuture}
 dateFuture={dateFuture}
 disablePast={disablePast}
 datePast={datePast}
 yearPicker={yearPicker}
/>
</fromFlow.When>
<fromFlow.When is={shouldRenderAddressPicker}>
<TysiaInputAddressPicker
  viewPath={`${viewPath}/TysiaInputAddressPicker`}
 innerRef={containerRef}
 onChooseAddress={onChooseAddress}
 onChange={onChange}
 value={value}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}